var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 23,
  fill: "url(#Check_svg__a)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 22.125,
  stroke: "#76E22E",
  strokeOpacity: 0.5,
  strokeWidth: 1.75
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Check_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#55C82D",
  d: "m8.749 23.957 10.124 10.102c.069.069.18.068.248 0l18.485-18.485a.175.175 0 0 0 0-.248l-3.702-3.702a.175.175 0 0 0-.248 0l-14.54 14.54a.175.175 0 0 1-.248 0l-6.175-6.163a.175.175 0 0 0-.247 0L8.749 23.71a.175.175 0 0 0 0 .248"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Check_svg__a",
  x1: 13.656,
  x2: 23,
  y1: 9.344,
  y2: 46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCFF01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6BF63B"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Check_svg__b",
  width: 28.96,
  height: 22.538,
  x: 8.697,
  y: 11.572,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.875
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})))));
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "Check.f2069d2c.svg";